export default __webpack_public_path__ + "static/media/instagram.fd47ee9f.svg";